import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { constants } from '../constants';
import { Login, UserModel } from '../models/user.model';
import { Observable } from 'rxjs';
import { PingModel } from '../models/ping.model';
import { map } from 'rxjs/operators';

@Injectable({
	providedIn: 'root'
})
export class AuthService
{

	private authenticatedUser: UserModel;

	constructor(private apiService: ApiService)
	{
		const localStorageUser = window.localStorage.getItem(constants.AUTHENTICATED_USER);

		if (localStorageUser)
		{
			this.authenticatedUser = JSON.parse(localStorageUser);
			this.apiService.setAuthUser(this.authenticatedUser);
		}
	}

	public login(username: string, password: string, locationId: number, appUse: string = constants.APP_USE.HOME): Promise<Login>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('username', username);
		httpParams = httpParams.set('password', password);
		httpParams = httpParams.set('location', locationId);
		httpParams = httpParams.set('app_use', appUse);

		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');

		return new Promise((resolutionFunc, rejectionFunc) =>
		{
			this.apiService.post<Login>('authenticate', headers, httpParams, false, constants.LOGIN_TIMEOUT).subscribe(response =>
			{
				if (response.success === true)
				{
					if (response.message !== constants.TWO_FACTOR_MESSAGE)
					{
						const authenticatedUser = new UserModel(response.username, response.token, response.exoid, locationId, appUse);
						this.authenticatedUser = authenticatedUser;
						this.apiService.setAuthUser(authenticatedUser);
						window.localStorage.setItem(constants.AUTHENTICATED_USER, authenticatedUser.serialize());
					}
					resolutionFunc(response);
				} else
				{
					rejectionFunc(response);
				}
			}, (err) =>
			{
				rejectionFunc(err.error);
			});
		});
	};

	public verifyTwoFactor(username: string,
		authCode: number,
		locationId: number,
		appUse: string = constants.APP_USE.HOME): Promise<Login>
	{
		let httpParams = new HttpParams();
		httpParams = httpParams.set('username', username);
		httpParams = httpParams.set('pin', authCode);
		httpParams = httpParams.set('app_use', appUse);

		let headers = new HttpHeaders();
		headers = headers.set('Content-Type', 'application/x-www-form-urlencoded');

		return new Promise((resolutionFunc, rejectionFunc) =>
		{
			this.apiService.post<Login>('two-factor-authentication', headers, httpParams).subscribe(response =>
			{
				if (response.success === true)
				{
					const authenticatedUser = new UserModel(response.username, response.token, response.exoid, locationId, appUse);
					this.authenticatedUser = authenticatedUser;
					this.apiService.setAuthUser(authenticatedUser);
					window.localStorage.setItem(constants.AUTHENTICATED_USER, authenticatedUser.serialize());
					resolutionFunc(response);
				} else
				{
					rejectionFunc(response);
				}
			}, err =>
			{
				rejectionFunc(err.error);
			});
		});
	}

	public getUser(): UserModel
	{
		return this.authenticatedUser;
	}

	public pingBackend(): Observable<PingModel>
	{
		return this.apiService.get('ping', null, null, true).pipe(
			map((ping: PingModel) => ping)
		);
	}

	public logout(): Observable<void>
	{
		return this.apiService.post('logout', null, null, true);
	}

	public isLoggedIn(): boolean
	{
		return this.authenticatedUser !== null &&
			this.authenticatedUser !== undefined &&
			this.authenticatedUser.token !== null &&
			this.authenticatedUser.token !== undefined;
	}
}
